import accounting from "accounting";

export function moneyFormat(number) {
  const options = {
    symbol: "€",
    decimal: ".",
    thousand: "'",
    precision: 2,
    format: "%s%v",
  };

  return accounting.formatMoney(number, options);
}

export function moneyUnformat(string) {
  if (string === "0.00") return 0;

  return string.trim().replaceAll("€", "").replaceAll("'", "");
}

export function calcDynamicPrecision({value, defaultPrecision = 2, dynamicPrecision = true, simpleZero = false}) {
  if (!value) return "";

  const stringValue = String(Number.parseFloat(typeof value === "string" ? value : String(value))) || "";
  const lastZeroIndex =
    dynamicPrecision &&
    stringValue &&
    (stringValue.includes("e-") ? +stringValue.slice(stringValue.lastIndexOf("-") + 1) : stringValue.lastIndexOf("0"));
  const doesPrecisionNeedToBeIncreased = +value < 1 && lastZeroIndex > defaultPrecision;
  const isZero = Number.parseFloat(value) === 0;

  return doesPrecisionNeedToBeIncreased && dynamicPrecision
    ? lastZeroIndex || defaultPrecision
    : isZero && simpleZero
    ? 0
    : defaultPrecision;
}

export function removeExcessiveZeros(stringNumber) {
  if (!stringNumber && typeof stringNumber !== "string") return stringNumber;

  const lastDotIndex = stringNumber?.lastIndexOf(".");
  const integerPart = stringNumber.slice(0, lastDotIndex);
  const fractionalPart = stringNumber.slice(lastDotIndex + 1);
  let lastNotZeroIndex = null;
  for (let i = stringNumber.length - 1; i >= 0; i--) {
    if (stringNumber[i] !== "0" && stringNumber[i] !== ".") {
      lastNotZeroIndex = i;
      break;
    }
  }
  // 9 for mm => m transfer in sku ovh
  const hasMultipleZerosAfterDot = /0{9,}/.test(String(fractionalPart));
  const match = fractionalPart.match(/0{9,}/)?.[0];
  const multipleZerosStartIndex = hasMultipleZerosAfterDot ? stringNumber.lastIndexOf(match) : null;
  let slicedStringNumber = multipleZerosStartIndex
    ? stringNumber.slice(0, multipleZerosStartIndex)
    : lastNotZeroIndex
    ? stringNumber?.slice(0, lastDotIndex + 1) + stringNumber?.slice(lastDotIndex + 1, lastNotZeroIndex + 1)
    : stringNumber;

  const slicedFractionalPart = slicedStringNumber.slice(slicedStringNumber.lastIndexOf(".") + 1);
  if (slicedFractionalPart?.length < 2) {
    slicedStringNumber =
      slicedStringNumber.slice(0, slicedStringNumber.lastIndexOf(".") + 1) + slicedFractionalPart.padEnd(2, "0");
  }

  const isOnlyZerosFraction = /^0+$/.test(fractionalPart);
  const fractionWithAberation = Number(integerPart) !== 0 && /^0{5,}[1-9]/.test(fractionalPart);

  return isOnlyZerosFraction || fractionWithAberation
    ? stringNumber.slice(0, lastDotIndex + 1) + "00"
    : slicedStringNumber;
}

export function numberFormat(number, precision = 2, isDynamic = true, areExcessiveZerosRemoved = true) {
  if (number === 0) return "0.00";
  if (!number) return "";
  if (number === "0.00") return number;
  const options = {
    decimal: ".",
    thousand: "'",
    precision: isDynamic ? calcDynamicPrecision({value: number, defaultPrecision: precision}) : precision,
    format: "%s%v",
  };
  const res = accounting.formatNumber(number, options);
  return res == 0 ? "" : areExcessiveZerosRemoved ? removeExcessiveZeros(res) : res;
}

export function numberPreciseFormat(number) {
  if (number === "0.00") return number;
  const options = {
    decimal: ".",
    thousand: "'",
    precision: 3,
    format: "%s%v",
  };
  const res = accounting.formatNumber(number, options);
  return res == 0 ? "" : removeExcessiveZeros(res);
}

export function simpleNumberFormat(number) {
  if (number === "0.00") return number;
  const options = {
    decimal: ".",
    precision: 2,
    format: "%s%v",
  };
  const res = accounting.formatNumber(number, options);
  return res == 0 ? "" : removeExcessiveZeros(res);
}

export function numberUnformat(string) {
  if (string === "0.00") return 0;
  const options = {
    decimal: ".",
    thousand: "'",
    precision: 2,
    format: "%s%v",
  };
  const res = accounting.unformat(string, options);
  return res == 0 ? "" : res;
}

export function numberUnformatCustom(string) {
  if (string === "0.00" || typeof string !== "string") return 0;

  return Number.parseFloat(string.trim().replaceAll("'", ""));
}
